import React, { Component } from 'react'
import Draggabilly from 'draggabilly'
import { injectIntl } from 'react-intl'
import messages from './messages'

import RelatedDocumentsDraggable from 'modules/RelatedDocuments/RelatedDocumentsDraggable'
import AppTools from 'utils/app/appTools'
import APPURL from 'utils/app/urls'
import DateTools from 'utils/dates/dateTools'
import IndicatorTools from 'utils/indicators/indicatorTools'
import MiniMap from 'modules/Content/MiniMap'

class ContentHeader extends Component {
	constructor(props) {
		super(props)
		const {
			intl: { formatMessage }
		} = props
		this.formatMessage = formatMessage
		AppTools.importFormatter(formatMessage)

		this.state = {
			relatedDocumentsOpen: false,
			relatedDocumentsAvailable: false,
			elementRef: null
		}

		this.relatedDocuments = null
	}

	componentDidUpdate() {
		if (this.state.elementRef) {
			let element = this.state.elementRef.current
			if (element) {
				this.relatedDocuments = new Draggabilly(element, {
					containment: '#root', // para evitar que se salga de los lÃ­mites del navegador
					handle: '.ork-related-documents__heading__drag'
				})
			}
		}
	}

	componentWillUnmount() {
		if (this.relatedDocuments !== null) {
			this.relatedDocuments.destroy()
		}
	}

	getRef = ref => {
		this.setState({
			elementRef: ref
		})
	}

	areRelatedDocumentsAvailable = available => {
		this.setState({ relatedDocumentsAvailable: available })
	}

	openRelatedDocuments = () => {
		if (this.relatedDocuments && this.state.elementRef) {
			const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
			const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
			const scroll = window.pageYOffset
			const element = this.state.elementRef.current
			const elementHeight = element.offsetHeight
			const elementWidth = element.offsetWidth

			let height = windowHeight / 2 - elementHeight / 2
			height = height + scroll
			if (height < scroll) height = scroll
			const width = windowWidth / 2 - elementWidth / 2

			this.relatedDocuments.setPosition(width, height)
			this.setState({
				relatedDocumentsOpen: true
			})
		}
	}

	closeRelatedDocuments = () => {
		if (this.relatedDocuments) {
			this.setState({
				relatedDocumentsOpen: false
			})
		}
	}

	renderLayer1Header() {
		const lastUpdated = DateTools.formatDateForContentHeader(this.props.lastUpdated)
		const methodologyLink = APPURL.getMethodologyLink(this.props.history.location.pathname)
		let header = (
			<React.Fragment>
				{/* <img className="framework-map" src={BASE_URL + '/img/framework.svg'} alt=""></img> */}
				<MiniMap/>
				<h2 dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.layer1Title, { lastUpdated }) }} />
				<p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.layer1Subtitle, { methodologyLink }) }} />
				<p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.knowMoreAboutMethodology, { methodologyLink }) }} />
				<p>
					<small dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.moreDataAvailableNote, { methodologyLink }) }} />
				</p>
			</React.Fragment>
		)
		return header
	}

	renderLayer2Header() {
		const lastUpdated = DateTools.formatDateForContentHeader(this.props.lastUpdated)
		const levelTitle = AppTools.getDimensionTitle(this.props.level)
		const methodologyLink = APPURL.getMethodologyLink(this.props.history.location.pathname)
		let subtitle = AppTools.getDimensionSubtitle( this.props.level );

		let header
		header = (
			<React.Fragment>
				<MiniMap dimension={this.props.level}/>
				<h2
					dangerouslySetInnerHTML={{
						__html: this.formatMessage(messages.layer2Title, { lastUpdated, levelNumber: levelTitle.levelNumber, levelName: levelTitle })
					}}
				/>
				<div className="ork-lead">
					<div className="ork-lead__text-wrapper">
						<p className="panel-description" dangerouslySetInnerHTML={{ __html: subtitle }} />
						<p className="panel-description" dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.knowMoreAboutMethodology, { methodologyLink }) }} />
					</div>
				</div>
			</React.Fragment>
		// 			{/* <div className="ork-lead__btn-wrapper">
	    //       <button
	    //         data-related-documents="related-documents"
	    //         className="btn btn-warning"
	    //         onClick={this.openRelatedDocuments}
	    //         disabled={!this.state.relatedDocumentsAvailable}
	    //       >
	    //         <i className="fal fa-file-alt fa-lg" data-related-documents="related-documents" />
		// 					&nbsp;
	    //         <span className="ork-u-ml" data-related-documents="related-documents">
	    //           {this.formatMessage(messages.relatedDocuments)}
	    //         </span>
	    //       </button>
	    //     </div> */}

		// 		{/* <RelatedDocumentsDraggable
	    //     getRef={this.getRef}
	    //     layer={2}
	    //     level={Number(this.props.level)}
	    //     open={this.state.relatedDocumentsOpen}
	    //     close={this.closeRelatedDocuments}
	    //     areAvailable={this.areRelatedDocumentsAvailable}
	    //   /> */}
		)
		return header
	}

	renderLayer3Header() {
		let header;
		let indicator_id = Number(this.props.indicator);
		const dimension = IndicatorTools.getDimensionFromIndicator(indicator_id);
		const indicatorData = this.props.indicatorsData.filter(item => Number(item.id) === Number(this.props.indicator))[0]
		const indicatorName = IndicatorTools.cleanIndicatorName(indicatorData.name);
		const indicatorUnit = indicatorData.unit
		const indicatorSource = AppTools.getComposedDataSource(indicatorData.dataSource)
		const indicatorLastUpdated = DateTools.formatDateForContentHeader(indicatorData.lastUpdated)
		const subTitle = `${this.formatMessage(messages.unit)}: ${indicatorUnit} ${indicatorSource !== '' ? '| ' + indicatorSource : ''}`

		header = (
			<React.Fragment>
				<MiniMap dimension={dimension}/>
				<h2 dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.layer3Title, { indicatorName, indicatorLastUpdated }) }} />
				<div className="ork-lead">
					<div className="ork-lead__text-wrapper">
						<p dangerouslySetInnerHTML={{ __html: subTitle }} />
					</div>
					<div className="ork-lead__btn-wrapper">
						{/* <button
	            data-related-documents="related-documents"
	            className="btn btn-warning"
	            onClick={this.openRelatedDocuments}
	            disabled={!this.state.relatedDocumentsAvailable}
	          >
	            <i className="fal fa-file-alt fa-lg" data-related-documents="related-documents" />
							&nbsp;
	            <span className="ork-u-ml" data-related-documents="related-documents">
	              {this.formatMessage(messages.relatedDocuments)}
	            </span>
	          </button> */}
					</div>
				</div>
				<RelatedDocumentsDraggable
					getRef={this.getRef}
					layer={this.props.layer}
					level={this.props.level}
					indicator={this.props.indicator}
					open={this.state.relatedDocumentsOpen}
					close={this.closeRelatedDocuments}
					areAvailable={this.areRelatedDocumentsAvailable}
				/>
			</React.Fragment>
		)
		return header
	}

	renderIfAllOK() {
		let renderingComponent = null
		switch (this.props.layer) {
			case 1:
				renderingComponent = this.renderLayer1Header()
				break
			case 2:
				renderingComponent = this.renderLayer2Header()
				break
			case 3:
				renderingComponent = this.renderLayer3Header()
				break
			default:
				renderingComponent = null
		}
		return renderingComponent
	}

	render() {
		return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(ContentHeader)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentHeader/ContentHeader.jsx